import React from 'react'
import { Chip } from 'components/Form'

const StatusCell = (props) => {
    const { has_new_message, ticket_message_count, status: messageStatus } = props

    const statuses = {
        "CLOSE": {
            label: "סגור",
            color: "gray"
        },
        "OPEN": {
            label: "ממתין לטיפול",
            color: "thirdly"
        },
        "INPROGRESS": {
            label: "נשלחה תשובה",
            color: "thirdly"
        },
        "NEW": {
            label: "חדש",
            color: "secondary"
        },
        "TO_BE_DEVELOPED": {
            label: "ממתין לפיתוח",
            color: "yellow"
        }
    }

    let status = {}
    if (messageStatus == 'CLOSE')
        status = statuses.CLOSE
    else if (messageStatus == 'TO_BE_DEVELOPED')
        status = statuses.TO_BE_DEVELOPED
    else if (!ticket_message_count)//there is no ticket messages
        status = statuses.NEW
    else if (has_new_message)// the last message was not answered
        status = statuses.OPEN
    else status = statuses.INPROGRESS

    return (
        <Chip color={status.color}>{status.label}</Chip>
    )
}

export default StatusCell